if (!customElements.get('product-form')) {
	const submitEvent = new Event('submit', {
		bubbles: true,
		cancelable: true,
	});

	const btnEvent = new Event('click', {
		bubbles: true,
		cancelable: true,
	});

	const custom_add_to_cart = document.querySelectorAll('[data-replo-add-product-variant-to-cart]');
	custom_add_to_cart.forEach((btn) => {
		btn.addEventListener('click', (evt) => {
			evt.preventDefault();

			const target = evt.target;
			const parent = target.closest('[data-replo-product-container] ');
			const form = parent.querySelector('product-form form');

			form.dispatchEvent(submitEvent);
		});
	});
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector('form');

				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
				this.submitButton = this.querySelector('[type="submit"]');

				this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
				this.submitButtonText = this.submitButton?.querySelector('span');
				if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

				this.hideErrors = this.dataset.hideErrors === 'true';
			}

			onSubmitHandler(evt) {
				evt.preventDefault();

				if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

				this.handleErrorMessage();

				this.submitButton?.setAttribute('aria-disabled', true);
				this.submitButton?.classList.add('loading');
				this.querySelector('.loading__spinner')?.classList.remove('hidden');

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const formData = new FormData(this.form);

				if (this.cart) {
					formData.append(
						'sections',
						this.cart.getSectionsToRender().map((section) => section.id),
					);
					formData.append('sections_url', window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;
				2;
				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								errors: response.errors || response.description,
								message: response.message,
							});

							this.handleErrorMessage(response?.description);

							const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
							if (!soldOutMessage) return;
							this.submitButton?.setAttribute('aria-disabled', true);
							this.submitButtonText?.classList.add('hidden');
							soldOutMessage?.classList.remove('hidden');
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								cartData: response,
							});
						this.error = false;
						const quickAddModal = this.closest('quick-add-modal');
						if (quickAddModal) {
							document.body.addEventListener(
								'modalClosed',
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true },
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton?.classList.remove('loading');
						if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
						if (!this.error) this.submitButton?.removeAttribute('aria-disabled');
						this.querySelector('.loading__spinner')?.classList.add('hidden');
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
				if (!this.errorMessageWrapper) return;
				this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}

			toggleSubmitButton(disable = true, text) {
				if (disable) {
					this.submitButton.setAttribute('disabled', 'disabled');
					if (text) this.submitButtonText.textContent = text;
				} else {
					this.submitButton.removeAttribute('disabled');
					this.submitButtonText.textContent = window.variantStrings.addToCart;
				}

				select_available_option();
			}

			get variantIdInput() {
				return this.form.querySelector('[name=id]');
			}
		},
	);
}

function select_available_option() {
	if (document.querySelector("[data-template='product.version-2']")) {
		const all_input_parents = document.querySelectorAll('.product__info-container variant-selects fieldset');
		all_input_parents?.forEach((parent) => {
			const inputs = parent?.querySelectorAll('input');

			if (inputs[0].getAttribute('data-available') === 'false') {
				const available_input = Array.from(inputs).find((input) => input.getAttribute('data-available') === 'true');
				const available_label = parent.querySelector(`label[data-title="${available_input?.value}"]`);
				available_label?.click();
			}
		});
	}
}
